import { REFUEL_DURATION, SWITCH_DURATION, SWITCH_DURATION_LOWER } from '@lp/features/RoutePlanner/config';
import { convertMsToTimeString, getColorsByOrganType, ORGAN_ICON } from '@/utils/helpers';
import { OrganType } from '@/api/apis/case';
import { LegTypeEnum } from '@/api/apis/route';
import {
  OPERATION_AT_HOSPITAL_DURATION_HEART,
  OPERATION_AT_HOSPITAL_DURATION_LIVER,
  OPERATION_AT_HOSPITAL_DURATION_LUNGS,
} from '@/utils/route';

const BASE_GROUND_BUFFERS_LIST = [
  {
    title: 'NOP Hub Car Loading/Unloading',
    timeMs: SWITCH_DURATION,
  },
  {
    title: 'FBO Car Loading/Unloading',
    timeMs: SWITCH_DURATION,
  },
  {
    title: 'Donor Hospital Car Loading/Unloading',
    timeMs: SWITCH_DURATION_LOWER,
  },
  {
    title: 'TX Center Car Loading/Unloading',
    timeMs: SWITCH_DURATION_LOWER,
  },
];

const BASE_AIR_BUFFERS_LIST = [
  {
    title: 'Plane Refueling',
    timeMs: REFUEL_DURATION,
  },
];

const getBuffersBaseList = (type: LegTypeEnum) => {
  return type === LegTypeEnum.air ? BASE_AIR_BUFFERS_LIST : BASE_GROUND_BUFFERS_LIST;
};

type TimeBuffersInfoProps = {
  type: LegTypeEnum;
  isReposition: boolean;
};

export const TimeBuffersInfo = ({ type, isReposition }: TimeBuffersInfoProps) => {
  const HeartIcon = ORGAN_ICON[OrganType.Heart];
  const LiverIcon = ORGAN_ICON[OrganType.Liver];
  const LungsIcon = ORGAN_ICON[OrganType.Lungs];

  const heartColor = getColorsByOrganType(OrganType.Heart);
  const liverColor = getColorsByOrganType(OrganType.Liver);
  const lungsColor = getColorsByOrganType(OrganType.Lungs);

  return (
    <div className="flex flex-col px-2 pt-2 pb-4">
      <span className="text-m-sb text-black mb-4">Time buffers</span>
      <div className="w-[502px]">
        {getBuffersBaseList(type).map((item) => (
          <div key={item.title} className="w-full flex h-7 border-b-1 border-base-60 items-center">
            <span className="text-s-sb w-[231px] text-base-5">{item.title}</span>
            <span className="pl-2 text-s-r text-black">{convertMsToTimeString(item.timeMs, 'short')}</span>
          </div>
        ))}
        <div className="w-full flex h-7 border-b-1 border-base-60 items-center">
          <span className="text-s-sb w-[231px] text-base-5">Donor OR departure</span>
          <div className="pl-2 flex gap-2">
            <div className="flex gap-1 items-center">
              <div className={`${heartColor.bg60} w-5 h-5 flex justify-center items-center rounded-full text-base-5 `}>
                <HeartIcon />
              </div>
              <span className="text-s-r text-black">
                {convertMsToTimeString(OPERATION_AT_HOSPITAL_DURATION_HEART, 'short')}
              </span>
            </div>
            <div className="flex gap-1 items-center">
              <div className={`${lungsColor.bg60} w-5 h-5 flex justify-center items-center rounded-full text-base-5 `}>
                <LungsIcon />
              </div>
              <span className="text-s-r text-black">
                {convertMsToTimeString(OPERATION_AT_HOSPITAL_DURATION_LUNGS, 'short')}
              </span>
            </div>
            <div className="flex gap-1 items-center">
              <div className={`${liverColor.bg60} w-5 h-5 flex justify-center items-center rounded-full text-base-5 `}>
                <LiverIcon />
              </div>
              <span className="text-s-r text-black">
                {convertMsToTimeString(OPERATION_AT_HOSPITAL_DURATION_LIVER, 'short')}
              </span>
            </div>
          </div>
        </div>
        {isReposition && (
          <div className="w-full flex h-7 border-b-1 border-base-60 items-center">
            <span className="text-s-sb w-[231px] text-base-5">Logistics resources at Donor OR</span>
            <div className="pl-2 flex gap-2">
              <div className="flex gap-1 items-center">
                <div
                  className={`${heartColor.bg60} w-5 h-5 flex justify-center items-center rounded-full text-base-5 `}
                >
                  <HeartIcon />
                </div>
                <span className="text-s-r text-black">OR+1:00h</span>
              </div>
              <div className="flex gap-1 items-center">
                <div
                  className={`${lungsColor.bg60} w-5 h-5 flex justify-center items-center rounded-full text-base-5 `}
                >
                  <LungsIcon />
                </div>
                <span className="text-s-r text-black">OR+1:00h</span>
              </div>
              <div className="flex gap-1 items-center">
                <div
                  className={`${liverColor.bg60} w-5 h-5 flex justify-center items-center rounded-full text-base-5 `}
                >
                  <LiverIcon />
                </div>
                <span className="text-s-r text-black">OR+4:00h</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
